import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { HOST, ROOT_URL, APP_URL } from '../../../../../config';
import EmailForm from './Form';

class CreateForm extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    if (this.props.params.id) {
      this.props.api.message.getData({ url: `/${this.props.params.id}/content` })
        .then(content => {
          this.props.api.message.setData({ attachments: content.attachments || [] });
        });
    } else {
      this.props.api.message.setData({ attachments: [] });
    }
  }
  render() {
    return (
      <EmailForm { ...this.props } showSaveButtons={ true } />
    );
  }
}
/* function handleSubmit(props, action = 'draft') {
  const reqUrl = action === 'send' ? '/send' : '/save-draft';
  console.log('action', action);
  props.api.message.setData({ loading: true });
  const xhr = new window.XMLHttpRequest();
  const formData = new window.FormData();
  const { attachments, ...data } = props.objectData;
  Object.keys(data).forEach(attr => {
    const value = data[attr];
    if (!!value) {
      if (typeof value === 'object') {
        formData.append(attr, JSON.stringify(value));
      } else {
        formData.append(attr, value);
      }
    }
  });
  let uploadUrl = HOST + ROOT_URL + APP_URL + '/messages' + reqUrl;
  if (data.id) {
    uploadUrl += `?id=${data.id}`;
  } else {
    formData.append('id', 0);
  }
  const previousAttachmentsNames = [];
  props.attachments.forEach((attachment, i) => {
    if (attachment.file) { // New uploaded file
      formData.append(`attachment-${i + 1}`, attachment.file);
    } else { // Old attachment
      previousAttachmentsNames.push(attachment.filename);
    }
  });
  formData.append('previousAttachments', JSON.stringify(previousAttachmentsNames));
  // Submit
  return new Promise((resolve, reject) => {
    xhr.open('POST', uploadUrl, true);
    const localData = localStorage.getItem('currentUser') || '{}';
    const jwt = JSON.parse(localData).jwt;
    if (jwt) { xhr.setRequestHeader('Authorization', `Bearer ${jwt}`); }
    xhr.onload = () => {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 400) {
          const successMessage = action === 'send' ? 'Email sent' : 'Email saved';
          console.log('successMessage', successMessage);
          props.api.message.setData({ loading: false, submitSuccessful: true, successMessage });
          if (action === 'send') {
            if (window.previousLocation && !window.previousLocation.match('/email/messages/new')) {
              props.router.push(window.previousLocation);
            } else {
              props.api.routing.redirect(props.router, '/email/messages');
            }
          }
          return resolve();
        } else {
          props.api.message.setData({ loading: false, error: xhr.statusText });
          return reject();
        }
      }
    };
    xhr.onerror = () => {
      props.api.message.setData({ loading: false, error: xhr.statusText });
      return reject();
    };
    xhr.send(formData);
  });
}*/

CreateForm.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
};

export default HyperdbForm(CreateForm, {
  namespace: 'message',
  mountedUrl: '/email/messages',
  titleNew: 'Create new email',
  titleEdit: 'Edit email',
  displaySaveButton: false,
  // onSubmit: handleSubmit,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/containers/CreateForm.jsx